function show(elementSelector, elementParent = document) {
  elementParent.querySelector(elementSelector)?.removeAttribute("hidden");
}
function showAll(elementSelector) {
  document.querySelectorAll(elementSelector).forEach(element => {
    element.removeAttribute("hidden");
  });
}
function hide(elementSelector, elementParent = document) {
  elementParent.querySelector(elementSelector)?.setAttribute("hidden", true);
}

function hideAll(elementSelector) {
  document.querySelectorAll(elementSelector).forEach(element => {
    element.setAttribute("hidden", true);
  });
}

function showError(element, message) {
  const errorElement = getNextErrorElement(element);
  if (!errorElement) return;
  errorElement.removeAttribute("hidden");
  errorElement.innerHTML = message;
}

function hideError(element) {
  const errorElement = getNextErrorElement(element);
  if (!errorElement) return;
  errorElement.setAttribute("hidden", true);
  errorElement.innerHTML = "";
}

function getNextErrorElement(element) {
  if (!element) return null;
  const parent = element.parentElement;
  const errorElement = parent.querySelector(".error");
  return errorElement || null;
}

function enableSubmitButton(button) {
  if (!button) return;
  button.removeAttribute("disabled");
  button.classList.remove("disabled");
}

function disableSubmitButton(button) {
  if (!button) return;
  button.setAttribute("disabled", true);
  button.classList.add("disabled");
}

function toggleButtonState(button, isEnabled) {
  if (!button) return;
  if (isEnabled) {
    button.removeAttribute("disabled");
    button.classList.remove("disabled");
  } else {
    button.setAttribute("disabled", true);
    button.classList.add("disabled");
  }
}

function getFullPhoneNumber() {
  const countryCode = document.querySelector(SELECTORS.countryCode)?.value.trim();
  const phoneNumber = document.querySelector(SELECTORS.phoneNumber)?.value.trim();

  if (!countryCode || !phoneNumber) {
    console.error("Country code or phone number is missing.");
    return null;
  }

  return `+${countryCode}${phoneNumber}`;
}